module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_034"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("This is embarrassing. Many veteran naval and marine pilots weren’t used to having to deal with landing gear. On a fighter like the Boeing F4B, the gear was always down. Grumman’s new planes were different—a flyer had to "), _c('em', [_vm._v("remember")]), _vm._v(" to lower the gear or there was going to be trouble. This Marine Corps F3F-2 came to a grinding halt at Turner Field, Virginia, in late 1937. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef08a2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_034.vue
// module id = 153
// module chunks = 0